module.exports = __webpack_public_path__ + "static/media/UG.0c3d01e7.png";